module.exports = __webpack_public_path__ + "4bc676d2a71df4192be89b8c3c80d21a.svg";